export default __webpack_public_path__ + "static/1980_1990-a5caba875407702b311596f9e8b33f5b.jpg";